import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/auth/login-form/login.component';
import { LogoutComponent } from './components/auth/logout/logout.component';
import { RegistroComponent } from './components/auth/registro/registro.component';
import { IdentGuard } from './guards/ident.guard';
import { IsAuthGuard } from './guards/isAuth.guard';
import { NoAuthGuard } from './guards/NoAuth.guard';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ChatComponent } from './components/chat/chat.component';
import { SearchClientComponent } from './components/search-client/search-client.component';
import { ConsultaPsicometricoComponent } from './components/consulta-psicometrico/consulta-psicometrico.component';
import { ListOnlineComponent } from './components/list-online/list-online.component';
import { profile } from 'console';
import { ProfilesComponent } from './components/profiles/profiles.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { ContactProfileComponent } from './components/contact-profile/contact-profile.component';
import { ConsultQuoteComponent } from './components/consult-quote/consult-quote.component';
import { CreditOptionComponent } from './components/credit-option/credit-option.component';
import { CreditCalculatorComponent } from './components/credit-calculator/credit-calculator.component';
import { CreditSaveComponent } from './components/credit-save/credit-save.component';
import { CreditSaveV2Component } from './components/credit-save-v2/credit-save-v2.component';
import { ConsultQuotaComponent } from './components/consult-quota/consult-quota.component';
import { InvoiceComponent } from './components/invoice/invoice.component';
import { ApproveConditionsComponent } from './components/approve-conditions/approve-conditions.component';
import { ApprovalPoliciesComponent } from './components/approval-policies/approval-policies.component';
import { ContactOnboardingComponent } from './components/contact-onboarding/contact-onboarding.component';
import { ContactSapComponent } from './components/contact-sap/contact-sap.component';
import { SapHubComponent } from './components/sap-hub/sap-hub.component';
import { PostComponent } from './components/post/post.component';
import { OtrosFlujosPagoComponent } from './components/otros-flujos-pago/otros-flujos-pago.component';
import { NotaCreditoComponent } from './components/nota-credito/nota-credito.component';
import { ContactFinancialPaymentsComponent } from './components/contact-financial-payments/contact-financial-payments.component';
import { PersonFeePaymentsComponent } from './components/person-fee-payments/person-fee-payments.component';

import { PersonPaymentsComponent } from './components/person-payments/person-payments.component';
import { PersonPaymentsTableComponent } from './components/person-payments-table/person-payments-table.component';
import { PersonPaymentsSwitcherComponent } from './components/person-payments-switcher/person-payments-switcher.component';
import { PreferenciasComponent } from './components/preferencias/preferencias.component';
import { WebcamComponent } from 'ngx-webcam';
import { BiometriaComponent } from './components/biometria/biometria.component';
import { FinancialPaymentsComponent } from './components/financial-payments/financial-payments.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { FinancePaymentsTableComponent } from './components/finance-payments-table/finance-payments-table.component';
import { FinancePaymentsSwitcherComponent } from './components/finance-payments-switcher/finance-payments-switcher.component';
import { DashboardFeesComponent } from './components/dashboard-fees/dashboard-fees.component';
import { ProcesosMasivosComponent } from './components/procesos-masivos/procesos-masivos.component';
import { ProcesoDetalleComponent } from './components/procesos-masivos/proceso-detalle/proceso-detalle.component';
import { CarteraComponent } from './components/cartera/cartera.component';
import { ClienteDetalleComponent } from './components/cliente-detalle/cliente-detalle.component';
import { NewFeeComponent } from './components/new-fee/new-fee.component';

import { StadisticComponent } from './components/stadistic/stadistic.component';
import { InstallmentsConsoleComponent } from './components/installments-console/installments-console.component';
import { ReportComponent } from './components/report/report.component';
import { ContactsApprovatedComponent } from './components/contacts-approvated/contacts-approvated.component';
import { ApproveConditinsViewComponent } from './components/approve-conditins-view/approve-conditins-view.component';
import { ExportComponent } from './components/export/export.component';
import { CreateContactComponent } from './components/create-contact/create-contact.component';
import { DashboardInviceComponent } from './components/dashboard-invice/dashboard-invice.component';
import { UsersComponent } from './components/users/users.component';
import { FinancalDashboardComponent } from './components/financal-dashboard/financal-dashboard.component';
import { VentasDashboardComponent } from './components/ventas-dashboard/ventas-dashboard.component';
import { Finanzas2DashboardComponent } from './components/finanzas2-dashboard/finanzas2-dashboard.component';
import { TdsManagementComponent } from './components/tds-management/tds-management.component';
import { CobranzaDashboardComponent } from './components/cobranza-dashboard/cobranza-dashboard.component';
import { CreditoDashboardComponent } from './components/credito-dashboard/credito-dashboard.component';
import { QuotaHistoryGlobalComponent } from './components/quota-history-global/quota-history-global.component';
import { ParametrosSistemaDashboardComponent } from './components/parametros-sistema-dashboard/parametros-sistema-dashboard.component';
import { StadisticDashboardComponent } from './components/stadistic-dashboard/stadistic-dashboard.component';
import { StadisticEjecutivesComponent } from './components/stadistic-ejecutives/stadistic-ejecutives.component';
import { IsProfileGuard } from './guards/isProfile.guard';
import { IsPermissionGuard } from './guards/isPermission.guard';
import { DashboardDirecDebitComponent } from './components/dashboard-direc-debit/dashboard-direc-debit.component';
import { DashboardDirectDebitAffiliationComponent } from './components/dashboard-direct-debit-affiliation/dashboard-direct-debit-affiliation.component';
import { DomiciliationConfigDashboardComponent } from './components/domiciliation-config-dashboard/domiciliation-config-dashboard.component';
import { RegistroCobrosArchivoComponent } from './components/registro-cobros-archivo/registro-cobros-archivo.component';

import { DirecDebitHistoryComponent } from './components/direc-debit-history/direc-debit-history.component';
import { DirecDebitAlliancesHistoryComponent } from './components/direc-debit-alliances-history/direc-debit-alliances-history.component';
import { DirecDebitAfiliationsHistoryComponent } from './components/direc-debit-afiliations-history/direc-debit-afiliations-history.component';

import { NotificationXlsxComponent } from './components/notification-xlsx/notification-xlsx.component';
import { RatesComponent } from './components/rates/rates.component';
import { AccountsAdminComponent } from './components/accounts-admin/accounts-admin.component';
import { PaymentOptionsComponent } from './components/payment-options/payment-options.component';
import { DeactivationCategoriesComponent } from './components/deactivation-categories/deactivation-categories.component';
import { CarteraCastigadaComponent } from './components/cartera-castigada/cartera-castigada.component';
import { BdvAsyncManagementComponent } from './components/bdv-async-management/bdv-async-management.component';
import { BdvConsultasComponent } from './components/bdv-consultas/bdv-consultas.component';

import { PlansComponent } from './components/plans/plans.component';
import { CargaMasivaClientComponent } from './components/carga-masiva-client/carga-masiva-client.component';
import { CargaMasivaAprobacionesComponent } from './components/carga-masiva-aprobaciones/carga-masiva-aprobaciones.component';
import { CargaMasivaCuposComponent } from './components/carga-masiva-cupos/carga-masiva-cupos.component';
import { CargaMasivaCuposRewardsComponent } from './components/carga-masiva-cupos-rewards/carga-masiva-cupos-rewards.component';
import { CargaMasivaC004Component } from './components/carga-masiva-c004/carga-masiva-c004.component';

import { DashboardDirecDebitAlliancesComponent } from './components/dashboard-direc-debit-alliances/dashboard-direc-debit-alliances.component';
import { ClientPlansComponent } from './components/person-plans/person-plans.component';
import { ClientsStadisticAuthComponent } from './components/clients-stadistic-auth/clients-stadistic-auth.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { InactiveQuotaComponent } from './inactive-quota/inactive-quota.component';
import { CodesComponent } from './components/codes/codes.component';
import { CodeDynamicComponent } from './code-dynamic/code-dynamic.component';
import { CodeTypeProductComponent } from './components/type-product/code-type-product/code-type-product.component';
import { PayallBalanceComponent } from './components/payall-balance/payall-balance.component';
import { RecargasComponent } from './components/recargas/recargas.component';
import { OperadorasListComponent } from './components/recargas/operadoras-list/operadoras-list.component';
import { TiposOperacionComponent } from './components/recargas/tipos-operacion/tipos-operacion.component';
import { ProductosComponent } from './components/recargas/productos/productos.component';
import { RecargasAdminComponent } from './admin/recargas-admin/recargas-admin.component';
import { PlanDetailComponent } from './components/plans/plan-detail/plan-detail.component';
import { PlansWizardComponent } from './components/plans/components/plans-wizard/plans-wizard.component';
import { PlansWizardEditComponent } from './components/plans/components/plans-wizard-edit/plans-wizard-edit.component';
import { DashboardRedistributePaymentComponent } from './components/dashboard-redistribute-payment/dashboard-redistribute-payment.component';
import { ClientInstallmentsViewComponent } from './components/client-installments-view/client-installments-view.component';
import { AsyncAdminDashboardComponent } from './components/async-admin-dashboard/async-admin-dashboard.component';
import { CashRegisterSimulatorComponent } from './components/cash-register-simulator/cash-register-simulator.component';
import { BancoPlazaConsoleComponent } from './components/banco-plaza-console/banco-plaza-console.component';
import { ShopsListComponent } from './components/shops/shops-list/shops-list.component';
import { ShopDetailComponent } from './components/shops/shop-detail/shop-detail.component';
import { SeguridadAvanzadaComponent } from './components/security/seguridad-avanzada/seguridad-avanzada.component';
import { AppClientsComponent } from './components/app-clients/app-clients.component';
import { RolesPermisosComponent } from './components/roles-permisos/roles-permisos.component';
import { InsuranceConsoleComponent } from './components/insurance-console/insurance-console.component';
import { AppConfigComponent } from './components/app-config/app-config.component';
import { CatalogProductsComponent } from './components/catalog-products/catalog-products.component';
import { CatalogProductDetailComponent } from './components/catalog-products/catalog-product-detail/catalog-product-detail.component';
import { InsuranceDomiciliationSimulatorComponent } from './components/insurance-domiciliation-simulator/insurance-domiciliation-simulator.component';

// Widget embebido CRM (sin auth guards — JWT via query param)
import { WidgetPaymentHistoryComponent } from './components/widget-payment-history/widget-payment-history.component';
import { WidgetCreditHistoryComponent } from './components/widget-credit-history/widget-credit-history.component';
import { WidgetPostComponent } from './components/widget-post/widget-post.component';
import { WidgetInstallmentsPlanComponent } from './components/widget-installments-plan/widget-installments-plan.component';

const routes: Routes = [
  /*{
    path: 'console',
    loadChildren: () => import('./modules/la/la.module').then(m => m.LaModule),
    canActivate: [AuthGuard]

  },*/
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'register',
    component: RegistroComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/financial-payments',
    component: FinancialPaymentsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/financial-payments/:shop',
    component: FinancialPaymentsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/payments',
    component: FinancePaymentsSwitcherComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    // Acceso directo a la vista tabla (fallback si falla la clásica)
    path: 'console/payments/tabla',
    component: FinancePaymentsTableComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    // Acceso directo a la vista clásica (fallback si falla la tabla)
    path: 'console/payments/classic',
    component: PaymentsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    path: 'console/fees',
    component: DashboardFeesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/insurance-domiciliation-simulator',
    component: InsuranceDomiciliationSimulatorComponent,
    canActivate: [IsAuthGuard],
  },

  {
    path: 'console/procesos-masivos',
    component: ProcesosMasivosComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: { profiles: ['OWNER', 'ADMIN', 'ANALIST'] },
  },
  {
    path: 'console/procesos-masivos/:id',
    component: ProcesoDetalleComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: { profiles: ['OWNER', 'ADMIN', 'ANALIST'] },
  },
  {
    path: 'console/cartera',
    component: CarteraComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: { profiles: ['OWNER', 'ADMIN', 'ANALIST'] },
  },
  {
    path: 'console/cliente/:code',
    component: ClienteDetalleComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: { profiles: ['OWNER', 'ADMIN', 'ANALIST'] },
  },

  {
    path: 'redirect',
    component: DashboardComponent,
    canActivate: [IsAuthGuard],
  },

  {
    path: 'console/dashboard',
    component: DashboardComponent,
    canActivate: [IsAuthGuard],
  },

  {
    path: 'console/constacts',
    component: ContactsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/users',
    component: UsersComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/create-constacts',
    component: CreateContactComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/constacts-status',
    component: ContactsApprovatedComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/search-client',
    component: SearchClientComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/psicometrico',
    component: ConsultaPsicometricoComponent,
    canActivate: [IsAuthGuard],
  },
  {
    path: 'console/person/profile/:code',
    component: ContactProfileComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    path: 'console/person/onboarding/:code',
    component: ContactOnboardingComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/person/sap/:code',
    component: ContactSapComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    path: 'console/sap-integracion',
    component: SapHubComponent,
    canActivate: [IsAuthGuard],
  },
  {
    path: 'console/person/financial-payments/:code',
    component: ContactFinancialPaymentsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/person/client-installments-view/:code',
    component: ClientInstallmentsViewComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/person/distri/:code',
    component: DashboardRedistributePaymentComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/online',
    component: ListOnlineComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/credit-option',
    component: CreditOptionComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/consult-quota',
    component: ConsultQuotaComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/credit-calculator',
    component: CreditCalculatorComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/credit-save',
    component: CreditSaveComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Nueva creación de crédito — ruta aparte a propósito: convive con la de
  // arriba para poder compararlas con datos reales antes de reemplazar nada.
  {
    path: 'console/credit-save-v2',
    component: CreditSaveV2Component,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/invoice-detail/:code',
    component: InvoiceComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  { path: 'client-quota', component: ConsultQuoteComponent },

  {
    path: 'verification/approve-conditions/:code',
    component: ApproveConditionsComponent,
  },

  {
    path: 'console/payment/:invoice/:installment',
    component: PostComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    path: 'console/post/person/:code_person/:fee/:installment',
    component: PostComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },

  {
    path: 'console/payments/person-fees/:code',
    component: PersonFeePaymentsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    // Ruta base: renderiza la vista (tabla o clásica) según la preferencia del admin.
    path: 'console/payments/person/:code',
    component: PersonPaymentsSwitcherComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    // Acceso directo a la vista de tabla (fallback / enlaces directos).
    path: 'console/payments/person/:code/tabla',
    component: PersonPaymentsTableComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },

  {
    path: 'console/post',
    component: PostComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },

  {
    path: 'console/post/person/:code_person',
    component: PostComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },

  // Otros flujos de pago: registrar sin conciliar / registrar y anular. Solo OWNER.
  {
    path: 'console/otros-flujos-pago/person/:code_person',
    component: OtrosFlujosPagoComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Nota de crédito: aplica una devolución a un crédito específico del cliente.
  // Va por RBAC (no por perfil fijo): el módulo debe poder asignarse a
  // colaboradores concretos desde Roles y Perfiles.
  {
    path: 'console/nota-credito/person/:code_person',
    component: NotaCreditoComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['pagos.nota_credito.read', 'pagos.nota_credito.create'],
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/stadistic',
    component: StadisticComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/export',
    component: ExportComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: [
        'reportes.cartera_clientes.export', 'reportes.cartera_credito.export',
        'reportes.clientes_domiciliados.export', 'reportes.cuotas.export',
        'reportes.distribucion_pagos.export', 'reportes.biometria.export',
        'reportes.pagos.export', 'reportes.estadistica_registros.export',
        'reportes.pagos_penalidades.export', 'reportes.penalidades.export',
        'reportes.planes_clientes.export', 'reportes.bdv_transacciones.export',
        'reportes.pagos_sap.export', 'reportes.giros_sap.export', 'reportes.sap_business_partner.export', 'reportes.sap_partidas_abiertas.export', 'reportes.sap_perdidas_incobrables.export',
        'reportes.seguros.export', 'reportes.pagos_seguros.export',
        'reportes.operativo_seguros.export', 'reportes.cartera_seguros.export',
        'reportes.pagos_seguro_kredit.export', 'reportes.cuotas_seguros.export',
        'reportes.sap_bdv_seguros.export', 'reportes.sap_mercantil_seguros.export',
        'reportes.sap_plaza_seguros.export'
      ],
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/installments-console',
    component: InstallmentsConsoleComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/stadistic_approved',
    component: ReportComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: [
        'reportes.cartera_clientes.export', 'reportes.cartera_credito.export',
        'reportes.clientes_domiciliados.export', 'reportes.cuotas.export',
        'reportes.distribucion_pagos.export', 'reportes.biometria.export',
        'reportes.pagos.export', 'reportes.estadistica_registros.export',
        'reportes.pagos_penalidades.export', 'reportes.penalidades.export',
        'reportes.planes_clientes.export', 'reportes.bdv_transacciones.export',
        'reportes.pagos_sap.export', 'reportes.giros_sap.export', 'reportes.sap_business_partner.export', 'reportes.sap_partidas_abiertas.export', 'reportes.sap_perdidas_incobrables.export',
        'reportes.fees_reactivacion.export'
      ],
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/invoice-dashboard',
    component: DashboardInviceComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/dashboard-direct-debit',
    component: DashboardDirecDebitComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/dashboard-direct-debit-alliances',
    component: DashboardDirecDebitAlliancesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/dashboard-direct-debit-affiliation',
    component: DashboardDirectDebitAffiliationComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/direct-debit-history',
    component: DirecDebitHistoryComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/domiciliation-config',
    component: DomiciliationConfigDashboardComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['cobranza.domiciliaciones.dashboard'],
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/registro-cobros-archivo',
    component: RegistroCobrosArchivoComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['cobranza.domiciliaciones.dashboard'],
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/direct-debit-afiliations-history',
    component: DirecDebitAfiliationsHistoryComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/direct-debit-alliances-history',
    component: DirecDebitAlliancesHistoryComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/finacial-dashboard',
    component: FinancalDashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST', 'FINANCIAL'],
    },
  },

  {
    path: 'console/ventas',
    component: VentasDashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/finanzas2',
    component: Finanzas2DashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST', 'FINANCIAL', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    path: 'console/transacciones-3ds',
    component: TdsManagementComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    // Mismo componente, abierto directo en la pestaña de Configuración 3DS.
    // Se enlaza desde "Parámetros de Sistema → Configuración 3DS".
    path: 'console/configuracion-3ds',
    component: TdsManagementComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL', 'ACCOUNTING_ANALYST'],
      startTab: 'config',
    },
  },

  {
    path: 'console/cobranza',
    component: CobranzaDashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST', 'FINANCIAL'],
    },
  },

  {
    path: 'console/credito',
    component: CreditoDashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/credito/quota-history-global',
    component: QuotaHistoryGlobalComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/parametros-sistema',
    component: ParametrosSistemaDashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/seguridad-avanzada',
    component: SeguridadAvanzadaComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.seguridad.read'],
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/app-clients',
    component: AppClientsComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.clientes_app.read'],
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/roles-permisos',
    component: RolesPermisosComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.roles_permisos.read'],
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/parametros-sistema/insurance-console',
    component: InsuranceConsoleComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/parametros-sistema/app-config',
    component: AppConfigComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/estadisticas',
    component: StadisticDashboardComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: [
        'reportes.cartera_clientes.export', 'reportes.cartera_credito.export',
        'reportes.clientes_domiciliados.export', 'reportes.cuotas.export',
        'reportes.distribucion_pagos.export', 'reportes.biometria.export',
        'reportes.pagos.export', 'reportes.estadistica_registros.export',
        'reportes.pagos_penalidades.export', 'reportes.penalidades.export',
        'reportes.planes_clientes.export', 'reportes.bdv_transacciones.export',
        'reportes.pagos_sap.export', 'reportes.giros_sap.export', 'reportes.sap_business_partner.export', 'reportes.sap_partidas_abiertas.export', 'reportes.sap_perdidas_incobrables.export',
        'reportes.fees_reactivacion.export'
      ],
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/notificacion-xlsx',
    component: NotificationXlsxComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/carga-masiva-cleinte-xlsx',
    component: CargaMasivaClientComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/carga-masiva-aprobaciones-xlsx',
    component: CargaMasivaAprobacionesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/carga-masiva-cupos',
    component: CargaMasivaCuposComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/carga-masiva-cupos-rewards',
    component: CargaMasivaCuposRewardsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/credito/reactivaciones-masivas',
    component: CargaMasivaC004Component,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/inactivate-quota',
    component: InactiveQuotaComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/estadisticas-ejecutivos',
    component: StadisticEjecutivesComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: [
        'reportes.cartera_clientes.export', 'reportes.cartera_credito.export',
        'reportes.clientes_domiciliados.export', 'reportes.cuotas.export',
        'reportes.distribucion_pagos.export', 'reportes.biometria.export',
        'reportes.pagos.export', 'reportes.estadistica_registros.export',
        'reportes.pagos_penalidades.export', 'reportes.penalidades.export',
        'reportes.planes_clientes.export', 'reportes.bdv_transacciones.export',
        'reportes.pagos_sap.export', 'reportes.giros_sap.export', 'reportes.sap_business_partner.export', 'reportes.sap_partidas_abiertas.export', 'reportes.sap_perdidas_incobrables.export',
        'reportes.fees_reactivacion.export'
      ],
      profiles: ['OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/rates',
    component: RatesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/accounts-admin',
    component: AccountsAdminComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/plans',
    component: PlansComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/plans/new',
    component: PlansWizardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/plans/edit/:code',
    component: PlansWizardEditComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/plans/detail/:code',
    component: PlanDetailComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/person/plans/:code',
    component: ClientPlansComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/client-stadistic',
    component: ClientsStadisticAuthComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/code-dynamic',
    component: CodeDynamicComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Duplicados eliminados: estadisticas-ejecutivos, rates, accounts-admin, plans, client-stadistic
  // (Ya definidos arriba con IsProfileGuard)

  {
    path: 'console/notifications',
    component: NotificationsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/codigos',
    component: CodesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/type_product',
    component: CodeTypeProductComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/payall-balance',
    component: PayallBalanceComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/recargas',
    component: RecargasComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
    children: [
      {
        path: '',
        redirectTo: 'operadoras',
        pathMatch: 'full'
      },
      {
        path: 'operadoras',
        component: OperadorasListComponent
      },
      {
        path: 'tipos/:code',
        component: TiposOperacionComponent
      },
      {
        path: 'productos/:operatorCode/:typeCode',
        component: ProductosComponent
      }
    ]
  },

  {
    path: 'console/recargas-admin',
    component: RecargasAdminComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // ===================================
  // SISTEMA DE GANANCIAS PAYALL (Módulo Lazy)
  // ===================================
  {
    path: 'console/ganancias',
    loadChildren: () => import('./components/ganancias/ganancias.module').then(m => m.GananciasModule),
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  // ===================================
  // SISTEMA DE PAYMENT OPTIONS
  // ===================================
  {
    path: 'console/payment-options',
    component: PaymentOptionsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/payment-options/:id/accounts',
    component: AccountsAdminComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Catálogo de categorías de desactivación de cupo
  {
    path: 'console/parametros-sistema/deactivation-categories',
    component: DeactivationCategoriesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Cartera Castigada (Pérdidas Incobrables)
  {
    path: 'console/parametros-sistema/cartera-castigada',
    component: CarteraCastigadaComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Preferencias de la consola
  {
    path: 'console/parametros-sistema/preferencias',
    component: PreferenciasComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.preferencias.read'],
      profiles: ['OWNER'],
    },
  },

  // Políticas de Aprobación
  {
    path: 'console/approval-policies',
    component: ApprovalPoliciesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/bdv-async-management',
    component: BdvAsyncManagementComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/bdv-consultas',
    component: BdvConsultasComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // ===================================
  // SIMULADOR DE CAJA REGISTRADORA
  // ===================================
  {
    path: 'console/caja',
    component: CashRegisterSimulatorComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  // ===================================
  // BANCO PLAZA - DÉBITO INMEDIATO
  // ===================================
  {
    path: 'console/banco-plaza',
    component: BancoPlazaConsoleComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  // ===================================
  // GESTIÓN DE TIENDAS
  // ===================================
  {
    path: 'console/shops',
    component: ShopsListComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/shops/:code',
    component: ShopDetailComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // ===================================
  // MÓDULO DE GESTIÓN DE PRODUCTOS
  // ===================================
  {
    path: 'console/catalog-products',
    component: CatalogProductsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/catalog-products/detail/:code',
    component: CatalogProductDetailComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  // Ruta raíz - redirecciona a create-constacts
  {
    path: '',
    redirectTo: '/console/create-constacts',
    pathMatch: 'full'
  },

  // Ruta para console sin subrutas - redirecciona a create-constacts
  {
    path: 'console',
    redirectTo: '/console/create-constacts',
    pathMatch: 'full'
  },
  {
    path: 'console/async-admin',
    component: AsyncAdminDashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Widget embebido CRM — sin auth guards, autenticado por JWT en query param
  {
    path: 'widget/payments/person/:personId',
    component: WidgetPaymentHistoryComponent,
  },
  {
    path: 'widget/credits/person/:personId',
    component: WidgetCreditHistoryComponent,
  },
  {
    path: 'widget/post/:code_person',
    component: WidgetPostComponent,
  },
  {
    path: 'widget/installments-plan/person/:personId',
    component: WidgetInstallmentsPlanComponent,
  },

  // Rutas no encontradas - redirecciona a create-constacts
  {
    path: '**',
    redirectTo: '/console/create-constacts',
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
